module.exports = __webpack_public_path__ + "static/media/connect.05c624ed.jpg";